import React, { Component } from 'react'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql, compose, withApollo } from 'react-apollo'
import {
  pageInfoFragment,
  companyFragment,
  viewerFragment,
  ownerFragment,
} from 'fragments'
import { message } from 'antd'
import { imagePath } from 'frontend_core/dist/helpers/image'
import BusinessLayout from 'components/layouts/BusinessLayout'
import Reservation from 'components/business/Reservation'
import Pager from 'components/business/shared/Pager'
import ReservationFilter from 'components/business/ReservationFilter'
import { setReservationFilter } from 'modules/reservationFilter'
import { setUIState, containerIds } from 'modules/ui'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { isPaid } from 'frontend_core/dist/helpers/format'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { STATUS } from 'modules/reservation'

class ReservationListContainer extends Component {
  formatCSVObject = reservation => {
    const question = []
    const answer = []
    const companyAnswers = reservation.companyAnswers.results
    companyAnswers.map(v => {
      question.push(v.questionTitle)
      answer.push(v.description)
    })
    if (companyAnswers.length < 5) {
      const array = new Array(5 - companyAnswers.length).fill('')
      question.push(...array)
      answer.push(...array)
    }
    const url = wwwUrl(
      `/spaces/${(reservation.space || {}).username}/rooms/${
        (reservation.room || {}).uid
      }`,
    )
    const {
      totalPayAmountForUserWithTaxText,
      totalCancelAmountForUserWithTaxText,
    } = reservation.billing
    return {
      予約リクエスト日: reservation.createdAtText,
      予約ID: reservation.id,
      利用者: `${reservation.user.contact.familyName} ${reservation.user.contact.givenName}`,
      利用日: reservation.startedAtText,
      料金:
        reservation.status === STATUS.REFUNDED
          ? `${totalCancelAmountForUserWithTaxText}`
          : `${totalPayAmountForUserWithTaxText}`,
      ステータス: `"${reservation.statusText}"`,
      スペース名: `"${reservation.room.name}"`,
      スペースURL: url,
      質問1: `"${question[0]}"`,
      回答1: `"${answer[0]}"`,
      質問2: `"${question[1]}"`,
      回答2: `"${answer[1]}"`,
      質問3: `"${question[2]}"`,
      回答3: `"${answer[2]}"`,
      質問4: `"${question[3]}"`,
      回答4: `"${answer[3]}"`,
      質問5: `"${question[4]}"`,
      回答5: `"${answer[4]}"`,
    }
  }

  json2csv = json => {
    return new Promise(resolve => {
      const header = Object.keys(json[0]).join(',') + '\n'

      const body = json
        .map(d => {
          return Object.keys(d)
            .map(key => {
              return d[key]
            })
            .join(',')
        })
        .join('\n')
      resolve(header + body)
    })
  }

  onClickCSVDownload = async e => {
    e.preventDefault()

    try {
      const results = await this.props.client.query({
        query: exportByCsvQuery,
        variables: {
          id:
            parseInt(queryString.parse(this.props.location.search).id, 10) ||
            null,
          startedAt: queryString.parse(this.props.location.search).startedAt
            ? moment(
                queryString.parse(this.props.location.search).startedAt,
              ).format()
            : null,
          endedAt: queryString.parse(this.props.location.search).endedAt
            ? moment(queryString.parse(this.props.location.search).endedAt)
                .add(1, 'day')
                .format()
            : null,
          status: queryString.parse(this.props.location.search).status || null,
          username: this.props.match.params.username,
          page: parseInt(
            queryString.parse(this.props.location.search).page || 1,
            10,
          ),
          perPage: 20,
        },
      })

      const { reservations } = results.data.company
      const formattedArray = reservations.results.map(result =>
        this.formatCSVObject(result),
      )
      const csv = await this.json2csv(formattedArray)
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom, csv], { type: 'text/csv' })
      const a = document.createElement('a')
      const date = moment().format('YYYYMMDD_HHmmssSSS') // 年月日_時分秒ミリ秒
      a.download = decodeURI(`${date}.csv`)
      if (window.navigator.msSaveBlob) {
        // for IE
        window.navigator.msSaveBlob(blob, a.download)
      } else {
        // for firefox & chrome & safari
        const url = window.URL.createObjectURL(blob)
        a.href = url
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    } catch (e) {
      message.warning(i18n.t('error.default.title'))
    }
  }

  render() {
    const { company } = this.props.data

    if (company && company.reservations.results) {
      return (
        <RenderResults
          {...this.props}
          onClickCSVDownload={this.onClickCSVDownload}
        />
      )
    } else {
      return <RenderZeroResults {...this.props} />
    }
  }
}

const RenderZeroResults = props => {
  return (
    <BusinessLayout
      title={i18n.t('server.business.reservations.title')}
      description={i18n.t('server.business.reservations.description')}
      {...props}
    >
      <div className="container">
        <div className="business-reservation__top">
          <h1 className="business__title business-reservation__title">
            {i18n.t('page.reservation_list.sectionTitle')}
          </h1>
          <ReservationFilter {...props} />
        </div>
        <p className="business-reservation__nothing">予約はまだありません。</p>
      </div>
    </BusinessLayout>
  )
}

const RenderResults = props => {
  const { data, onClickCSVDownload } = props
  const { variables } = data
  const { pageInfo, results } = data.company.reservations
  const queryParams = queryString.parse(props.location.search)
  const reservationFilterQueryParams = {
    id: queryParams.id,
    startedAt: queryParams.startedAt,
    endedAt: queryParams.endedAt,
    status: queryParams.status,
  }
  return (
    <BusinessLayout
      title={i18n.t('server.business.reservations.title')}
      description={i18n.t('server.business.reservations.description')}
      {...props}
    >
      <div className="container">
        <div className="business-reservation__top">
          <h1 className="business__title business-reservation__title">
            {i18n.t('page.reservation_list.sectionTitle')}
          </h1>
          <ReservationFilter {...props} />
        </div>
        <div className="business__supplement-wrap">
          <p className="business__supplement">
            お支払いの反映に時間がかかる場合があります。
          </p>
          <p>
            <a
              className="business-reservation__all-download"
              href="#"
              onClick={onClickCSVDownload}
            >
              <i className="icon icon-spm-download sm-hide mr5" />
              予約情報をCSVで一括ダウンロード
            </a>
          </p>
        </div>
      </div>
      <div className="container business-container">
        <div className="business-reservation__list">
          <table className="business-reservation__table">
            <tbody>
              <tr className="business-reservation__line">
                <th className="business-reservation__list-request-heading">
                  予約リクエスト日
                </th>
                <th className="business-reservation__list-id-heading">
                  予約ID
                </th>
                <th className="business-reservation__list-user-heading">
                  利用者
                </th>
                <th className="business-reservation__list-day-heading">
                  利用日
                </th>
                <th className="business-reservation__list-fee-heading">料金</th>
                <th className="business-reservation__list-status-heading">
                  ステータス
                </th>
              </tr>
              {results.map(reservation => (
                <Reservation
                  key={reservation.id}
                  reservation={reservation}
                  {...props}
                />
              ))}
            </tbody>
          </table>
        </div>
        {pageInfo.totalPages > 1 && (
          <Pager
            pathName={props.location.pathname}
            variables={variables}
            pageInfo={pageInfo}
            windowSize={1}
            queryParams={reservationFilterQueryParams}
          />
        )}
      </div>
    </BusinessLayout>
  )
}

const exportByCsvQuery = gql`
  query CSVBusinessAccountReservationListContainer($username: String!, $page: Int!, $perPage: Int, $id: Int, $startedAt: DateTime, $endedAt: DateTime, $status: ReservationPaymentStatusField) {
    company(username: $username) {
      id
      reservations(page: $page, perPage: $perPage, id: $id, startedAt: $startedAt, endedAt: $endedAt, paymentStatus: $status, orderBy: {field: CREATED_AT, direction: DESC}) {
        results {
          ... on Reservation {
            id
            status
            statusText
            createdAtText(format: "long")
            startedAtText(format: "long")
            billing {
              status
              totalPayAmountForUserWithTaxText
            }
            space {
              username
            }
            room {
              name
              uid
            }
            user {
              contact {
                givenName
                familyName
              }
            }
            companyAnswers {
              results {
                questionTitle,
                description,
              }
            }
          }
        }
        pageInfo {
          ${pageInfoFragment}
        }
      }
    }
  }
`

const containerWithApollo = compose(withApollo)(ReservationListContainer)

const withData = graphql(
  gql`
  query BusinessAccountReservationListContainer($username: String!, $page: Int!, $perPage: Int, $id: Int, $startedAt: DateTime, $endedAt: DateTime, $status: ReservationPaymentStatusField) {
    company(username: $username) {
      ${companyFragment}
      reservations(page: $page, perPage: $perPage, id: $id, startedAt: $startedAt, endedAt: $endedAt, paymentStatus: $status, orderBy: {field: CREATED_AT, direction: DESC}) {
        results {
          ... on Reservation {
            canShowReceipt(fromBusiness: true)
            id
            uid
            status
            statusText
            createdAtText(format: "long")
            startedAtText(format: "long")
            billing {
              totalPayAmountForUserWithTaxText
              totalCancelAmountForUserWithTaxText
              paymentMethod
            }
            user {
              contact {
                givenName
                familyName
              }
            }
          }
        }
        pageInfo {
          ${pageInfoFragment}
        }
      }
    }
    viewer {
      ${viewerFragment}
      companies(filter: MANAGED) {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {
        id: parseInt(queryString.parse(props.location.search).id, 10) || null,
        startedAt: queryString.parse(props.location.search).startedAt
          ? moment(queryString.parse(props.location.search).startedAt).format()
          : null,
        endedAt: queryString.parse(props.location.search).endedAt
          ? moment(queryString.parse(props.location.search).endedAt)
              .add(1, 'day')
              .format()
          : null,
        status: queryString.parse(props.location.search).status || null,
        username: props.match.params.username,
        page: parseInt(queryString.parse(props.location.search).page || 1, 10),
        perPage: 20,
      },
    }),
  },
)(containerWithApollo)

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState, setReservationFilter }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withData),
)
